// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3UXZW","inner":"Footer_inner__3bCQy"};